const isImgUrl = url => /\.(jpg|jpeg|png|webp|avif|gif)$/.test(url);

export default isImgUrl;
